/**
 * 商品画像アップロード (/api/products/upload-image) に渡すローカルファイルの判定。
 *
 * AVIF / HEIC / HEIF はサーバー側で PNG / JPEG に変換して保存する。HEIC は Chrome だと
 * File.type が空になることがあり、`type.startsWith('image/')` だけで判定すると選択が
 * 黙って無視されるので、拡張子でも判定する。
 * SVG は表示用の PNG に変換して保存し、原本も保持する (docs/features/product-image-vector-original-plan.md)。
 */

const UPLOADABLE_IMAGE_EXTENSIONS = ['png', 'jpg', 'jpeg', 'webp', 'gif', 'avif', 'heic', 'heif', 'svg'];

/** `<input type="file">` の accept。`image/*` だけだと HEIC を選べない環境があるので拡張子も並べる */
export const PRODUCT_IMAGE_ACCEPT = 'image/*,.heic,.heif,.avif,.svg';

/** SVG (ベクター) か。アップロード前の案内文に使う */
export function isVectorImageFile(file: File): boolean {
  return file.type === 'image/svg+xml' || fileExtension(file) === 'svg';
}

function fileExtension(file: File): string {
  const dot = file.name.lastIndexOf('.');
  return dot >= 0 ? file.name.slice(dot + 1).toLowerCase() : '';
}

/** 商品画像としてアップロードできるファイルか */
export function isUploadableProductImage(file: File): boolean {
  return file.type.startsWith('image/') || UPLOADABLE_IMAGE_EXTENSIONS.includes(fileExtension(file));
}
